/* EverMuse theme for EverMuseSA — vanilla JS, no dependencies.
   Modules: panels (menu/search/cart), cart, product form, gallery, predictive search,
   collection filters, recommendations, recently viewed, estimator, reveal-on-scroll. */
(function () {
  'use strict';

  var T = window.theme || {};
  var S = T.strings || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* storage unavailable */ } }
  };

  /* ---------- Money (mirrors Shopify's money_without_trailing_zeros) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') { cents = cents.indexOf('.') > -1 ? Math.round(parseFloat(cents) * 100) : parseInt(cents, 10); }
    var f = format || T.moneyFormat || 'R{{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(n) || n == null) { return '0'; }
      var parts = (n / 100).toFixed(precision).split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return d + (parts[1] ? decimal + parts[1] : '');
    }
    var m = f.match(re); var kind = m ? m[1] : 'amount'; var v;
    switch (kind) {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' ', '.'); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return f.replace(re, v).replace(/[.,]00(?!\d)/, '');
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg, isError) {
    var el = $('[data-toast]'); if (!el) { return; }
    el.textContent = msg; el.hidden = false;
    el.classList.toggle('toast--error', !!isError);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); setTimeout(function () { el.hidden = true; }, 350); }, 3200);
  }

  /* ---------- Panels: mobile menu, search, cart drawer ---------- */
  var activePanel = null, lastFocus = null;
  function overlayFor(panel) { return panel.parentElement && $(':scope > [data-overlay]', panel.parentElement); }
  function focusables(panel) { return $$('a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select, textarea, [tabindex]:not([tabindex="-1"])', panel).filter(function (e) { return e.offsetParent !== null; }); }
  function openPanel(panel, opener) {
    if (!panel) { return; }
    if (activePanel && activePanel !== panel) { closePanel(true); }
    lastFocus = opener || document.activeElement;
    panel.classList.add('is-open');
    var ov = overlayFor(panel); if (ov) { ov.classList.add('is-open'); }
    document.documentElement.style.overflow = 'hidden';
    activePanel = panel;
    if (opener) { opener.setAttribute('aria-expanded', 'true'); }
    setTimeout(function () {
      var target = $('[data-search-input]', panel) || focusables(panel)[0];
      if (target) { target.focus({ preventScroll: true }); }
    }, 60);
  }
  function closePanel(keepFocus) {
    if (!activePanel) { return; }
    var panel = activePanel;
    panel.classList.remove('is-open');
    var ov = overlayFor(panel); if (ov) { ov.classList.remove('is-open'); }
    document.documentElement.style.overflow = '';
    $$('[aria-expanded="true"][data-open-menu], [aria-expanded="true"][data-open-search]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    activePanel = null;
    if (!keepFocus && lastFocus && lastFocus.focus) { lastFocus.focus({ preventScroll: true }); }
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (activePanel) { closePanel(); return; }
      var lb = $('.lightbox'); if (lb) { lb.remove(); }
      $$('.nav__item.is-open').forEach(function (i) { i.classList.remove('is-open'); $('[data-dropdown-toggle]', i).setAttribute('aria-expanded', 'false'); });
    }
    if (e.key === 'Tab' && activePanel) {
      var f = focusables(activePanel); if (!f.length) { return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Before / after slider: native range input drives --pos. One short intro sweep reveals "After", then stops. */
  (function () {
    var wraps = $$('[data-ba]');
    if (!wraps.length) { return; }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    wraps.forEach(function (wrap) {
      var range = $('[data-ba-range]', wrap), stopped = false, raf = 0;
      function setPos(v) { wrap.style.setProperty('--pos', v + '%'); range.value = v; }
      function stop() { stopped = true; if (raf) { cancelAnimationFrame(raf); } }
      range.addEventListener('input', function () { stop(); wrap.style.setProperty('--pos', range.value + '%'); });
      ['pointerdown', 'keydown', 'focus'].forEach(function (ev) { range.addEventListener(ev, stop); });
      if (reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) { return; }
      function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
      function tween(from, to, ms, done) {
        var t0 = null;
        function step(ts) {
          if (stopped) { return; }
          if (t0 === null) { t0 = ts; }
          var k = Math.min(1, (ts - t0) / ms);
          setPos(from + (to - from) * ease(k));
          if (k < 1) { raf = requestAnimationFrame(step); } else if (done) { done(); }
        }
        raf = requestAnimationFrame(step);
      }
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) { return; }
        io.disconnect();
        setTimeout(function () {
          tween(50, 5, 1500, function () { setTimeout(function () { tween(5, 50, 1300); }, 900); });
        }, 400);
      }, { threshold: 0.6 });
      io.observe(wrap);
    });
  })();

  document.addEventListener('click', function (e) {
    var t = e.target;
    var rvToggle = t.closest('[data-rv-toggle]');
    if (rvToggle) {
      var mq = rvToggle.closest('section').querySelector('[data-rv-marquee]');
      var paused = mq.classList.toggle('is-paused');
      rvToggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
      rvToggle.querySelector('[data-rv-label]').textContent = paused ? 'Resume' : 'Pause';
      return;
    }
    var openMenu = t.closest('[data-open-menu]');
    if (openMenu) { openPanel($('[data-mobile-menu]'), openMenu); return; }
    var openSearch = t.closest('[data-open-search]');
    if (openSearch) { openPanel($('[data-search-panel]'), openSearch); return; }
    var openCart = t.closest('[data-open-cart]');
    if (openCart) {
      var drawer = $('[data-cart-drawer]');
      if (drawer && !$('[data-cart-page]')) { e.preventDefault(); openPanel(drawer, openCart); checkCart(); }
      return;
    }
    if (t.closest('[data-close]') || t.closest('[data-overlay]')) { closePanel(); return; }

    var dd = t.closest('[data-dropdown-toggle]');
    if (dd) {
      var item = dd.closest('[data-dropdown]'); var open = !item.classList.contains('is-open');
      $$('.nav__item.is-open').forEach(function (i) { i.classList.remove('is-open'); });
      item.classList.toggle('is-open', open); dd.setAttribute('aria-expanded', open ? 'true' : 'false'); return;
    }
    if (!t.closest('[data-dropdown]')) { $$('.nav__item.is-open').forEach(function (i) { i.classList.remove('is-open'); }); }
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]'), plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) { return; }
    var wrap = (minus || plus).closest('[data-qty]'); var input = $('input', wrap);
    var min = parseInt(input.min || '0', 10); var v = parseInt(input.value || '0', 10) || 0;
    v = minus ? Math.max(min, v - 1) : v + 1; input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Bundle pricing ----------
     What a shopper pays depends on how many UNITS of one product are in the bag:
       1 unit  -> the "1 unit" price          2 units -> the "2 units" bundle price
       3 units -> the "3 units" bundle price  4 or more -> the "1 unit" price x the number of units
     It works on the product's own variants (a single option named Bundle / Pack / Quantity / Units whose values
     contain a number), so every price still comes from Shopify and never from this file. */
  function unitsIn(text) {
    var parts = String(text == null ? '' : text).split(/\s+/);
    for (var i = 0; i < parts.length; i++) { if (/^\d+$/.test(parts[i]) && parseInt(parts[i], 10) > 0) { return parseInt(parts[i], 10); } }
    return 0;
  }
  function bundleModel(product) {
    if (!product || !product.variants || !product.options || product.options.length !== 1) { return null; }
    var first = product.options[0], name = String(first && first.name != null ? first.name : first).toLowerCase();
    if (!/bundle|pack|quantity|units/.test(name)) { return null; }
    var model = { byUnits: {}, unitsById: {}, tiers: 0 };
    product.variants.forEach(function (v) {
      var n = unitsIn(v.options ? v.options[0] : v.option1);
      if (!n) { return; }
      model.unitsById[v.id] = n;
      if (!model.byUnits[n]) { model.byUnits[n] = v; model.tiers++; }
    });
    return model.byUnits[1] && model.tiers > 1 ? model : null;
  }
  /* The variant + quantity that price `units` units: an exact bundle when one exists, otherwise single units. */
  function bundleTarget(model, units) {
    if (units < 1) { return null; }
    var tier = units > 1 ? model.byUnits[units] : null;
    if (tier && tier.available) { return { variant: tier, qty: 1 }; }
    var one = model.byUnits[1];
    return one && one.available ? { variant: one, qty: units } : null;
  }
  var bundleCache = {};
  function bundleInfo(handle) {
    if (!handle) { return Promise.resolve(null); }
    if (!bundleCache[handle]) {
      var base = String((T.routes && T.routes.root) || '/').replace(/\/$/, '');
      bundleCache[handle] = fetch(base + '/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) { throw new Error('product'); } return r.json(); })
        .then(bundleModel)
        .catch(function () { delete bundleCache[handle]; return null; });
    }
    return bundleCache[handle];
  }

  /* ---------- Cart ---------- */
  var cartBusy = false;
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.setAttribute('data-count', count); });
    var link = $('[data-open-cart]'); if (link) { link.setAttribute('aria-label', 'Shopping bag, ' + count + ' item' + (count === 1 ? '' : 's')); }
  }
  function sectionIds() {
    var ids = [];
    if ($('[data-cart-drawer]')) { ids.push('cart-drawer'); }
    var page = $('[data-cart-page]'); if (page) { ids.push(page.getAttribute('data-section-id')); }
    return ids;
  }
  function fetchCart() { return fetch(T.routes.cartJs, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function cartHandles(cart) {
    var list = [];
    (cart.items || []).forEach(function (it) { if (it.handle && list.indexOf(it.handle) < 0) { list.push(it.handle); } });
    return list;
  }
  /* Total units in the bag (a "2 units" bundle counts as 2). */
  function cartUnits(cart) {
    return Promise.all(cartHandles(cart).map(bundleInfo)).then(function (models) {
      var byHandle = {}; cartHandles(cart).forEach(function (h, i) { byHandle[h] = models[i]; });
      return (cart.items || []).reduce(function (sum, it) {
        var m = byHandle[it.handle], per = (m && m.unitsById[it.variant_id]) || 1;
        return sum + per * it.quantity;
      }, 0);
    });
  }
  /* Put `units` units of one product into the bag in its correct form. Resolves with the new cart.
     If Shopify refuses the bundle (for example it is out of stock), it falls back to single units; after a refusal
     the bag is read again, so a half-applied change can never leave the shopper with an emptied bag. */
  function applyBundle(cart, handle, model, units) {
    var candidates = [];
    if (units < 1) { candidates.push(null); }
    else {
      var best = bundleTarget(model, units), one = model.byUnits[1];
      if (best) { candidates.push(best); }
      if (units > 1 && one && one.available && (!best || best.variant.id !== one.id)) { candidates.push({ variant: one, qty: units }); }
    }
    if (!candidates.length) { return Promise.resolve(cart); }
    var lastErr = null;
    function attempt(i, cur) {
      if (i >= candidates.length) { return Promise.reject(lastErr || new Error(S.error)); }
      var have = {}, u = {}, t = candidates[i];
      cur.items.forEach(function (it) { if (it.handle === handle) { have[it.variant_id] = (have[it.variant_id] || 0) + it.quantity; u[it.variant_id] = 0; } });
      if (t) { u[t.variant.id] = t.qty; }
      if (Object.keys(u).every(function (id) { return (have[id] || 0) === u[id]; })) { return Promise.resolve(cur); }
      return postJSON(T.routes.cartUpdate || '/cart/update', { updates: u }).catch(function (err) {
        lastErr = err;
        return fetchCart().then(function (fresh) { return attempt(i + 1, fresh); });
      });
    }
    return attempt(0, cart);
  }
  /* Re-prices every bundle product in the bag. Never rejects: if it cannot, the bag is left as the shopper made it. */
  function normalizeCart(cart) {
    return cartHandles(cart).reduce(function (chain, handle) {
      return chain.then(function (cur) {
        var lines = cur.items.filter(function (it) { return it.handle === handle; });
        var plain = lines.some(function (it) { return (it.properties && Object.keys(it.properties).length) || it.selling_plan_allocation; });
        if (!lines.length || plain) { return cur; }
        return bundleInfo(handle).then(function (model) {
          if (!model || lines.some(function (it) { return !model.unitsById[it.variant_id]; })) { return cur; }
          var units = lines.reduce(function (sum, it) { return sum + model.unitsById[it.variant_id] * it.quantity; }, 0);
          return applyBundle(cur, handle, model, units).catch(function () { return fetchCart().catch(function () { return cur; }); });
        });
      });
    }, Promise.resolve(cart)).catch(function () { return cart; });
  }
  function refreshCart() {
    return fetchCart().then(normalizeCart).then(function (cart) {
      var ids = sectionIds();
      return Promise.all([
        cartUnits(cart),
        ids.length ? fetch(window.location.pathname + '?sections=' + ids.join(',')).then(function (r) { return r.json(); }) : Promise.resolve({})
      ]).then(function (res) {
        var sections = res[1];
        updateCount(res[0]);
        if (sections['cart-drawer']) {
          var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var fresh = $('[data-cart-drawer-inner]', doc), cur = $('[data-cart-drawer-inner]');
          if (fresh && cur) { cur.innerHTML = fresh.innerHTML; }
        }
        var page = $('[data-cart-page]');
        if (page && sections[page.getAttribute('data-section-id')]) {
          var d2 = new DOMParser().parseFromString(sections[page.getAttribute('data-section-id')], 'text/html');
          var np = $('[data-cart-page]', d2); if (np) { page.innerHTML = np.innerHTML; }
        }
        return cart;
      });
    });
  }
  /* Quietly fix a bag that was filled some other way (older visit, another tab); redraws only if something changed. */
  function checkCart() {
    return fetchCart().then(function (cart) {
      return normalizeCart(cart).then(function (fixed) { return fixed !== cart ? refreshCart() : cart; });
    }).catch(function () { /* leave the bag as it is */ });
  }
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var err = new Error(j.description || j.message || S.error); err.data = j; throw err; } return j; });
    });
  }
  function changeLine(line, qty, focusSel) {
    if (cartBusy) { return; } cartBusy = true;
    var wrap = $('[data-cart-drawer-inner]') || document.body; wrap.setAttribute('aria-busy', 'true');
    postJSON(T.routes.cartChange, { line: line, quantity: qty }).then(refreshCart).then(function () {
      if (focusSel) { var el = $(focusSel); if (el) { el.focus(); } }
    }).catch(function (err) { toast(err.message || S.error, true); refreshCart(); }).then(function () { cartBusy = false; wrap.removeAttribute('aria-busy'); });
  }
  /* Bundle products: the stepper counts UNITS. Work out the right bundle for the new total and swap the line. */
  function setBundleUnits(handle, units, focusSel, fallback) {
    bundleInfo(handle).then(function (model) {
      if (!model) { fallback(); return; }
      if (cartBusy) { return; } cartBusy = true;
      var wrap = $('[data-cart-drawer-inner]') || document.body; wrap.setAttribute('aria-busy', 'true');
      fetchCart().then(function (cart) { return applyBundle(cart, handle, model, units); }).then(refreshCart).then(function () {
        if (focusSel) { var el = $(focusSel); if (el) { el.focus(); } }
      }).catch(function (err) { toast(err.message || S.error, true); refreshCart(); }).then(function () { cartBusy = false; wrap.removeAttribute('aria-busy'); });
    });
  }
  document.addEventListener('change', function (e) {
    var input = e.target.closest('input[data-line]');
    if (!input) { return; }
    var qty = Math.max(0, parseInt(input.value || '0', 10) || 0);
    var line = parseInt(input.getAttribute('data-line'), 10), handle = input.getAttribute('data-bundle');
    if (handle) {
      var per = parseInt(input.getAttribute('data-units') || '1', 10) || 1;
      setBundleUnits(handle, qty, '#' + input.id, function () { changeLine(line, Math.ceil(qty / per), '#' + input.id); });
      return;
    }
    changeLine(line, qty, '#' + input.id);
  });

  /* Before leaving for checkout, make sure the bag is priced correctly (covers a bag filled in another tab or an older visit). */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#CartDrawerForm, #cart-form');
    if (!form || form.getAttribute('data-checking')) { return; }
    var sub = e.submitter;
    if (sub && sub.name !== 'checkout') { return; }
    e.preventDefault();
    form.setAttribute('data-checking', 'true');
    var go = function () {
      /* the bag may have been redrawn while it was being checked, so find the form again */
      var live = (form.id && document.getElementById(form.id)) || form;
      var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = ''; live.appendChild(h);
      live.submit();
    };
    checkCart().then(go, go);
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove-line]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.getAttribute('data-remove-line'), 10), 0); }
  });

  /* Discount code: Shopify applies codes via /discount/CODE */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-apply-code]')) { return; }
    var input = $('#DiscountCode'); var code = input && input.value.trim();
    if (!code) { toast('Please enter a discount code', true); input && input.focus(); return; }
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(T.routes.cart);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.id === 'DiscountCode') { e.preventDefault(); $('[data-apply-code]').click(); }
  });

  /* Add to cart (product page + quick add)
     Only one add can be in progress at a time: pressing Enter in the quantity box, a double tap or an impatient
     second click while the bag is still updating must never add the item again. */
  var adding = false, buyNowClick = false;
  /* older browsers do not say which button submitted the form, so remember the last click as well */
  document.addEventListener('click', function (e) { buyNowClick = !!e.target.closest('[data-buy-now]'); }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form], form[data-quick-add]');
    if (!form) { return; }
    e.preventDefault();
    if (adding) { return; }
    var idInput = $('[name=id]', form);
    if (!idInput || idInput.disabled) { return; }
    adding = true;
    /* "Buy it now" = the same add, then straight to checkout */
    var buyNow = !!(e.submitter && e.submitter.hasAttribute && e.submitter.hasAttribute('data-buy-now')) || buyNowClick;
    buyNowClick = false;
    var leaving = false;
    var btns = buyNow ? $$('[data-buy-now]', form) : $$('[data-add-button]', form).concat($$('[data-sticky-button]'));
    var errBox = $('[data-form-error]', form); if (errBox) { errBox.hidden = true; }
    btns.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-disabled', 'true'); });
    var fd = new FormData(form);
    var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
    postJSON('/cart/add.js', { items: [{ id: parseInt(fd.get('id'), 10), quantity: qty }] })
      .then(refreshCart)
      .then(function () {
        if (buyNow) { leaving = true; window.location.href = String((T.routes && T.routes.root) || '/').replace(/\/$/, '') + '/checkout'; return; }
        if ($('[data-cart-drawer]') && !$('[data-cart-page]')) { openPanel($('[data-cart-drawer]'), $('[data-open-cart]')); }
        else { toast(S.added); }
      })
      .catch(function (err) {
        if (errBox) { errBox.textContent = err.message || S.error; errBox.hidden = false; } else { toast(err.message || S.error, true); }
      })
      .then(function () { if (leaving) { return; } adding = false; btns.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-disabled'); }); });
  });

  /* Coming back with the Back button (for example from checkout) can show an old copy of the page: refresh the bag. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) { return; }
    adding = false;
    $$('[data-add-button], [data-buy-now], [data-sticky-button]').forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-disabled'); });
    refreshCart().catch(function () { /* ignore */ });
  });

  if ($('[data-cart-page]')) { checkCart(); }

  /* Shipping estimator (Shopify cart shipping-rates API) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-est-button]'); if (!btn) { return; }
    var box = btn.closest('[data-estimator]');
    var zip = $('[data-est-zip]', box).value.trim(), country = $('[data-est-country]', box).value;
    var out = $('[data-est-result]', box);
    if (!zip) { out.innerHTML = '<li class="error">Please enter your postal code.</li>'; return; }
    out.innerHTML = '<li>Checking rates…</li>';
    var q = 'shipping_address[zip]=' + encodeURIComponent(zip) + '&shipping_address[country]=' + encodeURIComponent(country);
    fetch('/cart/prepare_shipping_rates.json?' + q, { method: 'POST' }).then(function () {
      var tries = 0;
      (function poll() {
        fetch('/cart/async_shipping_rates.json?' + q).then(function (r) { return r.status === 202 ? null : r.json(); }).then(function (j) {
          if (j === null && tries++ < 8) { return setTimeout(poll, 700); }
          var rates = j && j.shipping_rates || [];
          if (!rates.length) { out.innerHTML = '<li class="error">No delivery options found for that address. You can still try checkout.</li>'; return; }
          out.innerHTML = rates.map(function (r) { return '<li><span>' + esc(r.presentment_name || r.name) + '</span><strong>' + (parseFloat(r.price) === 0 ? 'Free' : esc(formatMoney(r.price))) + '</strong></li>'; }).join('');
        }).catch(function () { out.innerHTML = '<li class="error">' + esc(S.error) + '</li>'; });
      })();
    }).catch(function () { out.innerHTML = '<li class="error">' + esc(S.error) + '</li>'; });
  });

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var jsonEl = $('[data-product-json]'); if (!jsonEl) { return; }
    var product = JSON.parse(jsonEl.textContent);
    var form = $('[data-product-form]', root);
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-button]', form), addLabel = $('[data-add-label]', form), buyBtn = $('[data-buy-now]', form);
    var sticky = $('[data-sticky-atc]'), stickyBtn = sticky && $('[data-sticky-button]', sticky), stickyPrice = sticky && $('[data-sticky-price]', sticky);
    var stockEl = $('[data-stock]', root), priceWrap = $('[data-price]', root);
    var meta = {}; try { meta = JSON.parse($('[data-product-meta]').textContent); } catch (e) { /* ignore */ }
    var stock = { threshold: 0, variants: {} }; try { stock = JSON.parse($('[data-stock-json]').textContent); } catch (e) { /* ignore */ }
    var viewport = $('[data-viewport]', root);
    var qtyInput = $('[data-qty] input', form), qtyHidden = $('[data-form-quantity]', form), totalEl = $('[data-buy-total]', form);
    var model = bundleModel(product);
    if (model && product.handle && !bundleCache[product.handle]) { bundleCache[product.handle] = Promise.resolve(model); }
    var chosen = null;
    product.variants.forEach(function (v) { if (idInput && String(v.id) === String(idInput.value)) { chosen = v; } });

    /* The stepper counts units. Turn "units" into the bundle variant + quantity that Shopify prices correctly,
       and write them into the real form fields so Add to bag AND Buy now / express checkout charge the same amount. */
    function syncForm() {
      if (!chosen || !idInput) { return; }
      var q = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var id = chosen.id, qty = q, target = null, units = model && model.unitsById[chosen.id] ? model.unitsById[chosen.id] * q : 0;
      if (units) { target = bundleTarget(model, units); if (target) { id = target.variant.id; qty = target.qty; } }
      idInput.value = id; if (qtyHidden) { qtyHidden.value = qty; }
      if (totalEl) {
        if (target && units > 1) {
          totalEl.textContent = units + ' units: ' + formatMoney(target.variant.price * target.qty) + (target.qty > 1 ? ' (' + formatMoney(target.variant.price) + ' each)' : ' (bundle price)');
          totalEl.hidden = false;
        } else { totalEl.hidden = true; totalEl.textContent = ''; }
      }
    }
    if (qtyInput) { qtyInput.addEventListener('change', syncForm); qtyInput.addEventListener('input', syncForm); }

    function selected() {
      var opts = [];
      $$('[data-option-input]:checked', root).forEach(function (i) { opts[parseInt(i.getAttribute('data-option-position'), 10) - 1] = i.value; });
      return opts;
    }
    function findVariant(opts) {
      return product.variants.filter(function (v) { return opts.every(function (o, i) { return o === undefined || v.options[i] === o; }); })[0];
    }
    function setState(v) {
      var ok = !!v && v.available;
      if (addBtn) { addBtn.disabled = !ok; }
      if (buyBtn) { buyBtn.hidden = !ok; buyBtn.disabled = !ok; }
      if (addLabel) { addLabel.textContent = !v ? S.unavailable : ok ? S.addToBag : S.soldOut; }
      if (stickyBtn) { stickyBtn.disabled = !ok; stickyBtn.textContent = !v ? S.unavailable : ok ? S.addToBag : S.soldOut; }
      chosen = v || null;
      if (idInput) { idInput.disabled = !ok; syncForm(); }
      if (stockEl) {
        var q = v && stock.variants ? stock.variants[v.id] : null;
        var low = ok && stock.threshold > 0 && typeof q === 'number' && q > 0 && q <= stock.threshold;
        stockEl.textContent = !v ? S.unavailable : !ok ? S.soldOut : low ? (q === 1 ? S.lowStockOne : S.lowStock.replace('{n}', q)) : S.inStock;
        stockEl.classList.toggle('stock--out', !ok);
        stockEl.classList.toggle('stock--low', !!low);
      }
      if (v && priceWrap) {
        var p = formatMoney(v.price);
        priceWrap.className = 'price' + (v.compare_at_price > v.price ? ' price--sale' : '');
        priceWrap.innerHTML = v.compare_at_price > v.price
          ? '<span class="price__now">' + esc(p) + '</span> <s class="price__compare">' + esc(formatMoney(v.compare_at_price)) + '</s>'
          : '<span class="price__now">' + esc(p) + '</span>';
        if (stickyPrice) { stickyPrice.textContent = p; }
      }
      if (v) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        if (v.featured_media && v.featured_media.id && viewport) {
          var slide = $('[data-media-id="' + v.featured_media.id + '"]', viewport);
          if (slide) { viewport.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' }); }
        }
      }
      $$('[data-option-position]', root).forEach(function (fs) {
        var lbl = $('[data-option-label]', fs), chk = $('input:checked', fs);
        if (lbl && chk) { lbl.textContent = chk.value; }
      });
    }
    $$('[data-option-input]', root).forEach(function (i) { i.addEventListener('change', function () { setState(findVariant(selected())); }); });

    /* Gallery */
    var thumbs = $$('[data-thumb]', root), dots = $$('[data-dot]', root), slides = $$('[data-slide]', root);
    function markCurrent(idx) {
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
    }
    function goTo(idx) { if (slides[idx]) { viewport.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' }); } }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
    if (viewport) {
      var raf; viewport.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { markCurrent(Math.round(viewport.scrollLeft / Math.max(1, viewport.clientWidth))); });
      }, { passive: true });
      viewport.addEventListener('keydown', function (e) {
        var cur = Math.round(viewport.scrollLeft / Math.max(1, viewport.clientWidth));
        if (e.key === 'ArrowRight') { goTo(Math.min(slides.length - 1, cur + 1)); }
        if (e.key === 'ArrowLeft') { goTo(Math.max(0, cur - 1)); }
      });
      viewport.addEventListener('click', function (e) {
        var s = e.target.closest('[data-zoom]'); if (!s) { return; }
        var lb = document.createElement('div'); lb.className = 'lightbox'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-label', 'Zoomed image');
        lb.innerHTML = '<button type="button" class="icon-btn lightbox__close" aria-label="Close zoomed image"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"><path d="m6 6 12 12M18 6 6 18"/></svg></button><img alt="" src="' + esc(s.getAttribute('data-zoom')) + '">';
        lb.addEventListener('click', function () { lb.remove(); });
        document.body.appendChild(lb); $('button', lb).focus();
      });
    }

    /* Sticky add-to-bag on mobile: show once the main button scrolls out of view */
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var out = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', out); sticky.setAttribute('aria-hidden', out ? 'false' : 'true');
        if (stickyBtn) { stickyBtn.tabIndex = out ? 0 : -1; }
      });
      io.observe(addBtn);
    }

    /* Recently viewed: record this product */
    try {
      var list = JSON.parse(store.get('evermuse:recent') || '[]').filter(function (h) { return h !== product.handle; });
      list.unshift(product.handle); store.set('evermuse:recent', JSON.stringify(list.slice(0, 12)));
    } catch (e) { /* ignore */ }

    if (meta && meta.bundlePos) { setState(findVariant(selected())); } else { syncForm(); }
  }
  var prodRoot = $('[data-product]'); if (prodRoot) { initProduct(prodRoot); }

  /* ---------- Recently viewed ---------- */
  (function () {
    var box = $('[data-recently-viewed]'); if (!box) { return; }
    var current = box.getAttribute('data-current'), list = [];
    try { list = JSON.parse(store.get('evermuse:recent') || '[]'); } catch (e) { list = []; }
    list = list.filter(function (h) { return h !== current; }).slice(0, 4);
    if (!list.length) { return; }
    Promise.all(list.map(function (h) { return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); })).then(function (items) {
      items = items.filter(Boolean); if (!items.length) { return; }
      $('[data-recently-viewed-grid]', box).innerHTML = items.map(function (p) {
        var img = p.featured_image ? '<img class="pcard__img" src="' + esc(p.featured_image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '';
        return '<article class="pcard"><a class="pcard__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a><div class="pcard__body"><h3 class="pcard__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3><div class="price"><span class="price__now">' + esc(formatMoney(p.price)) + '</span></div></div></article>';
      }).join('');
      box.hidden = false;
    });
  })();

  /* ---------- Recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url'); if (!url) { return; }
    fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (!html.trim()) { return; }
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; }
    }).catch(function () { /* recommendations are optional */ });
  });

  /* ---------- Predictive search ---------- */
  (function () {
    var input = $('[data-search-input]'), out = $('[data-predictive]'); if (!input || !out) { return; }
    var timer, ctl;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (ctl) { ctl.abort(); } ctl = new AbortController();
        var url = T.routes.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { signal: ctl.signal }).then(function (r) { return r.json(); }).then(function (j) {
          var items = (j.resources && j.resources.results && j.resources.results.products) || [];
          if (!items.length) { out.innerHTML = '<p class="predictive__empty">' + esc(S.noResults) + ' for &ldquo;' + esc(q) + '&rdquo;</p>'; return; }
          out.innerHTML = '<div class="predictive__list">' + items.map(function (p) {
            return '<a class="predictive__item" href="' + esc(p.url) + '"><img src="' + esc(p.image || '') + '" alt="" width="64" height="64" loading="lazy"><span>' + esc(p.title) + '</span><span class="muted">' + esc(formatMoney(p.price)) + '</span></a>';
          }).join('') + '</div><a class="link-arrow predictive__all" href="' + T.routes.search + '?q=' + encodeURIComponent(q) + '">' + esc(S.viewAll) + '</a>';
        }).catch(function (err) { if (err.name !== 'AbortError') { out.innerHTML = ''; } });
      }, 220);
    });
  })();

  /* ---------- Collection filters / sort ---------- */
  (function () {
    var form = $('[data-facet-form]'); if (!form) { return; }
    var sub; function submitSoon() { clearTimeout(sub); sub = setTimeout(function () { form.requestSubmit ? form.requestSubmit() : form.submit(); }, 250); }
    form.addEventListener('change', function (e) { if (window.matchMedia('(min-width: 990px)').matches && e.target.type !== 'number') { submitSoon(); } });
    $$('[data-auto-submit]').forEach(function (s) { s.addEventListener('change', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); }); });
    // Remove empty inputs so URLs stay clean
    form.addEventListener('submit', function () { $$('input[type=number]', form).forEach(function (i) { if (!i.value) { i.disabled = true; } }); var m = $('[data-sort-mirror]', form); if (m) { m.disabled = true; } });
    var open = $('[data-open-filters]'), close = $('[data-close-filters]');
    if (open) { open.addEventListener('click', function () { form.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; open.setAttribute('aria-expanded', 'true'); }); }
    if (close) { close.addEventListener('click', function () { form.classList.remove('is-open'); document.documentElement.style.overflow = ''; if (open) { open.setAttribute('aria-expanded', 'false'); } }); }
  })();

  /* ---------- LED light modes (tabs) ---------- */
  (function () {
    function activate(root, tab, focus) {
      var tabs = $$('[data-mode-tab]', root), panels = $$('[data-mode-panel]', root), i = tabs.indexOf(tab);
      if (i < 0) { return; }
      tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
      panels.forEach(function (p, j) { p.classList.toggle('is-active', j === i); });
      if (focus) { tab.focus(); }
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-mode-tab]') : null;
      if (t) { activate(t.closest('[data-modes]'), t); }
    });
    document.addEventListener('keydown', function (e) {
      var t = e.target.closest ? e.target.closest('[data-mode-tab]') : null; if (!t) { return; }
      var root = t.closest('[data-modes]'), tabs = $$('[data-mode-tab]', root), i = tabs.indexOf(t), next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = tabs[(i + 1) % tabs.length]; }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = tabs[(i - 1 + tabs.length) % tabs.length]; }
      else if (e.key === 'Home') { next = tabs[0]; }
      else if (e.key === 'End') { next = tabs[tabs.length - 1]; }
      if (next) { e.preventDefault(); activate(root, next, true); }
    });
    // In the theme editor, selecting a block in the sidebar shows its card.
    document.addEventListener('shopify:block:select', function (e) {
      var panel = e.target.closest ? e.target.closest('[data-mode-panel]') : null; if (!panel) { return; }
      var root = panel.closest('[data-modes]'), idx = $$('[data-mode-panel]', root).indexOf(panel);
      activate(root, $$('[data-mode-tab]', root)[idx]);
    });
  })();

  /* ---------- Misc ---------- */
  var focusMsg = $('[data-autofocus]'); if (focusMsg) { focusMsg.focus(); focusMsg.scrollIntoView({ block: 'center' }); }

  /* Scroll reveal (progressive enhancement; skipped in the theme editor and for reduced motion) */
  (function () {
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
    var els = $$('.section-head, .cat-card, .pcard, .col-item, .step, .mode, .trust__item, .editorial, .spotlight');
    els.forEach(function (el) { el.classList.add('reveal'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
    // Safety net: never leave content hidden
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 4000);
  })();
})();
